import { useAtom }   from "jotai";
import { useRouter } from "next/router";

import { useGetDeviceType } from "_common/hooks/global";
import { searchTermAtom }   from "_jotai/search";

import MobilePresentation from "./mobile.presentation";
import Presentation       from "./presentation";

const component = ( { search_query, tab, tabs, initialData } ) => {
	const router     = useRouter ();
	const deviceType = useGetDeviceType ();

	const [ searchTerm, setSearchTerm ] = useAtom ( searchTermAtom );

	const isMobileOrTablet = deviceType === "mobile" || deviceType === "tablet";

	const changeSearchTab = tab => {
		return router.push ( `/results/${ encodeURIComponent ( search_query ) }?tab=${ tab }`, undefined, { shallow: false } );
	};

	if ( isMobileOrTablet ) {
		return (
			<MobilePresentation
				activeTab     = { tab }
				changeTab     = { changeSearchTab }
				initialData   = { initialData }
				searchTerm    = { searchTerm }
				setSearchTerm = { setSearchTerm }
				tabs          = { tabs }
			/>
		);
	}

	return (
		<Presentation
			activeTab     = { tab }
			changeTab     = { changeSearchTab }
			initialData   = { initialData }
			searchQuery   = { search_query }
			searchTerm    = { searchTerm }
			setSearchTerm = { setSearchTerm }
			tabs          = { tabs }
		/>
	);
};

export default component;
